import { filterJobsToRange, inRangeYMD, rangeBounds } from "../dateRange";

// Date range options — "All" is handled separately as a standalone button
const DATE_RANGES = [
  { key: "mtd",        label: "This month"   },
  { key: "qtd",        label: "This quarter" },
  { key: "ytd",        label: "This year"    },
  { key: "prior_year", label: "Last year"    },
];

// Use actual current date for date range calculations
const MOCK_TODAY = new Date();

// Jobs narrowed to the selected range (see src/dateRange.js). Revenue and costs include labor, manual
// expenses and manual revenue; dated items are placed by their date text, undated money is left out.
function filterJobsByDate(jobs, rangeKey, customStart, customEnd) {
  return filterJobsToRange(jobs, rangeKey, customStart, customEnd, MOCK_TODAY);
}

function filterUntaggedByDate(items, rangeKey, customStart, customEnd) {
  const b = rangeBounds(rangeKey, customStart, customEnd, MOCK_TODAY);
  if (!b) return items;
  return items.filter(u => inRangeYMD(u.date, b.start, b.end));
}

export { DATE_RANGES, MOCK_TODAY, filterJobsByDate, filterUntaggedByDate };
